export default __webpack_public_path__ + "static/media/excellent.fb0d3f7e.svg";